import { axios, API, SendRequest } from "@/imports-files/components/model/setup-video-qa";


export class VideoQAModalService extends SendRequest {
   
     async getJobList(params) 
     {
        try {
            let url = API.VIDEO_QA_INTERVIEW.SHOW.replace('$job_stage_id', params.job_stage_id).replace('$job_id', params.job_id)
            const result = await axios.get( url,
                {
                    headers: this.customHeaderJSON()
                },
                this.setHeaderJSON(),
                this.setCrossDomainTrue(),
                this.setCredentialsJSON());
            return result;
        }
        catch (error) {
            return error;
        }
    }

     async createQuestions(params) 
     {
        try {
            let url = API.VIDEO_QA_INTERVIEW.CREATE.replace('$job_stage_id', params.job_stage_id).replace('$job_id', params.job_id)
            const result = await axios.post( url,
                params,
                this.setHeaderJSON(),
                this.setCrossDomainTrue(),
                this.setCredentialsJSON());
            return result;
        }
        catch (error) {
            return error;
        }
    }

     async updateQuestions(params) 
     {
       try {
            let url = API.VIDEO_QA_INTERVIEW.UPDATE.replace('$job_stage_id', params.job_stage_id).replace('$job_id', params.job_id)
            const result = await axios.patch( url,
                params,
                this.setHeaderJSON(),
                this.setCrossDomainTrue(),
                this.setCredentialsJSON());
            return result;
        }
        catch (error) {
            return error;
        }
    }
}